module.exports = __webpack_public_path__ + "img/terroir-disc-1.b776ce99.jpg";